import {useState, useEffect, useCallback, useMemo} from 'react';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog, {DialogProps} from '@mui/material/Dialog';

import {yupResolver} from '@hookform/resolvers/yup';
import {useForm, FormProvider, Controller} from 'react-hook-form';
import * as Yup from 'yup';
import {RadioGroup, FormControlLabel, Typography, Radio} from '@mui/material';
import {
  getSearchForm,
  getLMSResultsData,
  postCourseData
} from '@shared/services/service-handlers/PrivateService';

import EncryptUtils from 'src/utils/EncryptUtils';
import selflearnin from '../selflearnin.png';
import blendedlearning from '../blendedlearning.png';
import {LoadingButton} from '@mui/lab';
import {useAppContext} from '@context/AppContext';
// ----------------------------------------------------------------------

interface Props extends DialogProps {
  title?: string;
  //
  onCreate?: (data: any) => void;
  onUpdate?: VoidFunction;
  //
  folderName?: string;
  onChangeFolderName?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  //
  open: boolean;
  onClose: VoidFunction;
}
const courseType = [
  {typecourse: 1, name: 'Self Learning', image: selflearnin}
];
export default function CreateCourse({
  title = 'Upload Files',
  open,
  onClose,
  //
  onCreate,
  onUpdate,
  //
  folderName,
  onChangeFolderName,
  ...other
}: Props) {
  const {
    appState: {applicationName}
  } = useAppContext();
  const [isSubmitting, setisSubmitting] = useState(false);
  const NewJobSchema = Yup.object().shape({
    Title: Yup.string().required('Title is required'),
    CourseType: Yup.number().required('Content is required')
  });
  const defaultValues = useMemo(
    () => ({
      Title: '',
      CourseType: 1
    }),
    [open]
  );
  const methods = useForm({
    resolver: yupResolver(NewJobSchema),
    defaultValues,
    mode: 'onBlur'
  });
  const {
    control,
    formState: {errors},
    handleSubmit
  } = methods;
  console.log('control', control, errors);
  const onSubmit = async (datavalue: any) => {
    try {
      console.log('errors', errors);
      console.log(datavalue);
      setisSubmitting(true);
      const response = await getSearchForm('LMS', 'overview');
      const encryptRequestDatavalue = EncryptUtils.encryptedData(response);

      // console.log('uniqueId', uniqueId, recordId);
      const {sql_data} = response.searchForm.document_getdata_sql;
      const data: any = {
        sql_data: sql_data,
        data: {
          id: '',
          name: datavalue.Title,
          course_type_id: datavalue.CourseType
        },
        operation: 'INSERT'
      };
      console.log('dara', data);
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getLMSResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      // const datacatogory = await postCourseData('LMS', 'CourseType', {
      //   tk: encryptRequestDatavalue
      // });
      console.log('result', result);
      // setdatarecieved(true);

      if (onCreate) {
        onCreate(result.data[0].id);
      }
      // onClose();
      setisSubmitting(false);
    } catch (e) {
      console.log(e);
      setisSubmitting(false);
    }
  };
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{p: theme => theme.spacing(3, 3, 2, 3)}}>
        {' '}
        {title}{' '}
      </DialogTitle>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent dividers sx={{pt: 1, pb: 0, border: 'none'}}>
            <Controller
              name="Title"
              control={control}
              render={({field}) => (
                <TextField
                  {...field}
                  label="Title"
                  size="medium"
                  fullWidth
                  error={!!errors.Title}
                  helperText={errors.Title?.message}
                  sx={{mb: 3}}
                />
              )}
            />
            <Controller
              name="CourseType"
              control={control}
              render={({field}) => (
                <RadioGroup {...field} row>
                  {courseType.map(coursetype => (
                    <FormControlLabel
                      key={coursetype.typecourse}
                      value={String(coursetype.typecourse)}
                      control={<Radio />}
                      label={
                        <Stack alignItems="center">
                          <img
                            src={coursetype.image}
                            alt={coursetype.name}
                            style={{width: '10vh'}}
                          />
                          <Typography>{coursetype.name}</Typography>
                        </Stack>
                      }
                    />
                  ))}
                </RadioGroup>
              )}
            />
          </DialogContent>

          <DialogActions>
            <Stack direction="row" justifyContent="flex-end" flexGrow={1}>
              <LoadingButton
                variant="contained"
                type="submit"
                color="success"
                loading={isSubmitting}>
                Create
              </LoadingButton>
            </Stack>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
}
